import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { ProgressMeterService } from '../services/progress-meter.service';

@Injectable()
export class BasicInterceptor implements HttpInterceptor {
  constructor(private _progressMeterService: ProgressMeterService) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    this._progressMeterService.changeStatus(true);
    return next.handle(request).pipe(
      finalize(() => {
        this._progressMeterService.changeStatus(false);
      }),
    );
  }
}
